import styled from 'styled-components';
import { device } from '../../media_queries';

const DashUserMain = styled.section`
  width: 100%;
  /* height: 100%; */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-top: 5%;
  @media ${device.mobileS} {

  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {

  }
  @media ${device.desktop} {
    
  }
`;

export { DashUserMain };